import { Stack, Typography } from "@mui/material";
import { CalendarIcon } from "../../../images/CalendarIcon";

export const WeekBlock = ({ week }: { week: string }) => {
  if (!week) return null;
  return (
    <Stack flexDirection="row" gap="4px" alignItems="center">
      <CalendarIcon width="16px" height="16px" color="#005EAB" />
      <Typography
        sx={{
          fontSize: "12px",
          lineHeight: "12px",
          fontWeight: 500,
          color: "#005EAB",
        }}
      >
        {week}
      </Typography>
    </Stack>
  );
};
